'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function CloseButton(props) {
  if (props.display) {
    return _react2.default.createElement(
      'a',
      { className: 'pxl-modal__close', 'aria-label': 'Close', onClick: props.onClick },
      _react2.default.createElement('i', { className: 'icon-cancel' })
    );
  }
  return null;
};

CloseButton.propTypes = {
  display: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};

exports.default = CloseButton;